<script>
  import { layoutMethods, customerMethods} from "@/state/helpers";
  import topupTransaction from "@/views/pages/profileInformation/wallet/eload/topup";
  import sellEloadTransaction from "@/views/pages/profileInformation/wallet/eload/sellEload";

  /**
   * E-Load Transaction component
   */
  export default {
    page: {
      title: "E-Load Transaction"
    },
    components: {
      topupTransaction,
      sellEloadTransaction,
    },
    computed: {
    },
    data() {
      return {
        title: "E-Load Transaction",
        businessId: 0,
        walletInfo:{
          eloadBalance: 0,
          walletAddress: null,
          storeOwner:null,
          businessName:null
        },
        financeInfo:{
          monthlyIncoming: 0,
          monthlyOutgoing: 0,
          dailyIncoming: 0,
          dailyOutgoing: 0,
          currentDate:null
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...customerMethods,
      async getBusinessEloadHeader(){
        await this.actionBusinessInfos({
            action: "business-eload-transaction",
            body: {id: this.businessId}
        }).then((res)=>{
          console.log(":: business-eload-transaction ::", JSON.stringify(res));
          var data = res.message[0]
          this.walletInfo = {
            eloadBalance: data.eloadBalance,
            walletAddress: data.cogUserSub,
            storeOwner:data.storeOwner,
            businessName:data.businessName,
          },
          this.financeInfo = {
            monthlyIncoming: data.monthlyIncoming,
            monthlyOutgoing: data.monthlyOutgoing,
            dailyIncoming: data.dailyIncoming,
            dailyOutgoing: data.dailyOutgoing,
            currentDate: data.currentDate
          }
          // console.log(`:: getBusinessEloadHeader :: `, JSON.stringify(res));
        })
      }
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.getBusinessEloadHeader();
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card"><!--E-Load transaction header-->
      <div class="card-body py-0"> 
        <div class="row">
          <div class="col-sm-12 col-md-5"><!--Wallet Information-->
            <div class="border-bottom text-dark mb-3 py-2">
                <div class="flex-grow-1 my-auto pt-1 " @click="getBusinessEloadHeader">
                    <h5 class="mb-0 font-size-14 mt-1">Wallet Information</h5>
                </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-4"><!-- E-Load Wallet-->
                <div class="d-flex align-items-center">
                    <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                        <i class='mdi mdi-wallet'></i>
                    </div>
                    <div class="">
                        <p class="mb-1 font-size-13">E-Load Wallet</p>
                        <label class="mb-1">
                          {{ walletInfo.eloadBalance | numberWithCommas }}
                        </label>
                    </div>
                </div>
              </div><!-- E-Load Wallet-->
              <div class="col-md-6 mb-2"><!-- Wallet Address-->
                <div class="d-flex align-items-center">
                    <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                      <feather type="globe" size="20"></feather>
                    </div>
                    <div class="">
                        <p class="mb-1 font-size-13">Wallet Address</p>
                        <label class="mb-1">
                          {{walletInfo.walletAddress ? walletInfo.walletAddress : "-"}}
                        </label>
                    </div>
                </div>
              </div><!-- Wallet Address-->
              <div class="col-md-6 mb-4"><!-- Store Owner-->
                <div class="d-flex align-items-center">
                    <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                        <i class="bx bx-user-circle"></i>
                    </div>
                    <div class="">
                        <p class="mb-1 font-size-13">Store Owner</p>
                        <label class="mb-1 text-capitalize">
                          {{ walletInfo.storeOwner ? walletInfo.storeOwner : '-'}}
                        </label>
                    </div>
                </div>
              </div><!-- Store Owner-->
              <div class="col-md-6 mb-2"><!-- BusinessName-->
                <div class="d-flex align-items-center">
                    <div class="font-size-20 text-secondary flex-shrink-0 me-2 fw-semibold">
                        <i class="bx bx-store-alt"></i>
                    </div>
                    <div class="">
                        <p class="mb-1 font-size-13">BusinessName</p>
                        <label class="mb-1 text-capitalize"> 
                          {{walletInfo.businessName ? walletInfo.businessName : '-'}}
                        </label>
                    </div>
                </div>
              </div><!-- BusinessName-->
            </div>
          </div><!--Wallet Information-->

          <div class="col-sm-12 col-md-7"><!--Financial Overview-->
            <div class="border-bottom text-dark mb-3 py-2">
                <div class="flex-grow-1 my-auto pt-1 row">
                    <h5 class="mb-0 font-size-14 col-6 mt-1">Financial Overview</h5>
                </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-4"><!-- Monthly Incomimg-->
                <p class="m-0 font-size-13">Monthly Incoming</p>
                <label>{{ financeInfo.monthlyIncoming | numberWithCommas }}</label>
              </div><!-- Monthly Incomimg-->
              <div class="col-md-6 mb-4"><!-- Monthly Outgoing-->
                <p class="m-0 font-size-13">Monthly Outgoing</p>
                <label>{{ financeInfo.monthlyOutgoing | numberWithCommas }}</label>
              </div><!-- Monthly Outgoing-->
              <div class="col-md-6"><!-- Daily Incoming-->
                <p class="m-0 font-size-13">Daily Incoming</p>
                <label class="m-0">{{ financeInfo.dailyIncoming | numberWithCommas }}</label>
                <p class="font-size-12" style="font-weight: 500;">
                  <span v-if="financeInfo.currentDate">
                    as of {{ financeInfo.currentDate | formatDate }}
                  </span>
                  <span v-else>-</span>
                </p>
              </div><!-- Daily Incoming-->
              <div class="col-md-6 mb-2"><!-- Daily Outgoing-->
                <p class="m-0 font-size-13">Daily Outgoing</p>
                <label class="m-0">{{ financeInfo.dailyOutgoing | numberWithCommas }}</label>
                <p class="font-size-12" style="font-weight: 500;">
                  <span v-if="financeInfo.currentDate">
                    as of {{ financeInfo.currentDate | formatDate }}
                  </span>
                  <span v-else>-</span>
                </p>
              </div><!-- Daily Outgoing-->
            </div>
          </div><!--Financial Overview-->
        </div>
      </div>
    </div><!--E-Load transaction header-->
    <div class="card"><!--Eload Transaction Body-->
      <div class="card-body">
        <b-tabs
          content-class="p-3 text-muted"
          nav-class="nav-tabs-custom"
        >
          <b-tab active class="border-0"><!--Topup transactions-->
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Top-ups</span>
            </template>

            <topup-transaction/>
          </b-tab><!--Topup transactions-->

          <b-tab><!-- Sell eload transactions-->
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Sell-eload</span>
            </template>

            <sell-eload-transaction/>
          </b-tab><!-- Sell eload transactions-->
        </b-tabs>
      </div>
    </div><!--Eload Transaction Body-->
  </div> <!-- end of outer div-->
</template>

<style>
</style>